export default function periodUnit(period) {
  // monthly -> month, yearly -> year
  return period.replace(/ly$/, '');
}
